import { Suspense, lazy } from "react";
import { Outlet, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { AppProvider } from "src/contexts/AppContext";
import { AuthProvider } from "src/contexts/AuthContext";
import { LocaleProvider } from "src/contexts/LocaleContext";
import { SocketProvider } from "src/contexts/SocketContext";

const MessengerPage = lazy(() => import("src/modules/messenger/MessengerPage"));
const Error404 = lazy(() => import("src/modules/errors/404/Error404"));
const Error503 = lazy(() => import("src/modules/errors/503/Error503"));

// Suspensed View
const SV = ({ element }) => (
  <Suspense
    fallback={
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    }
  >
    {element}
  </Suspense>
);

// App Layout
const AppLayout = () => {
  return (
    <AppProvider>
      <AuthProvider>
        <LocaleProvider>
          <SocketProvider>
            <Outlet />
          </SocketProvider>
        </LocaleProvider>
      </AuthProvider>
    </AppProvider>
  );
};

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/:company" element={<AppLayout />}>
          <Route index element={<SV element={<MessengerPage />} />} />
          <Route path="messenger/*" element={<SV element={<MessengerPage />} />} />
        </Route>
        <Route path="/404" element={<SV element={<Error404 />} />} />
        <Route path="/503" element={<SV element={<Error503 />} />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
